<div class="tw-w-full tw-h-full tw-bg-teal-100 tw-rounded-3 tw-px-6 tw-py-9">
  <waiting-for-call (buttonClicked)="onContinue()">
    <p slot="sub-header" class="tw-text-300 tw-text-gray-500 tw-text-center tw-font-body tw-mt-8" i18n="@@yourCheckupIsInProcess">Your checkup is in progress</p>
    <h2 slot="header" class="tw-text-600 tw-text-black tw-mt-2 tw-text-center tw-font-bold tw-mb-7">
      <ng-container [ngSwitch]="timeService.getDoctorCallTiming()">
        <span *ngSwitchCase="'working'" i18n="@@doctorCallWithin2To3HoursBr">Your doctor will call you <br /> within 2-3 hours</span>
        <span *ngSwitchCase="'evening'" i18n="@@doctorCallTomorrowBr">Your doctor will call you <br /> tomorrow</span>
        <span *ngSwitchCase="'early'" i18n="@@doctorCallAfter8AMTodayBr">Your doctor will call you <br /> after 8 AM today</span>
      </ng-container>
    </h2>
    <p slot="button-text" class="tw-text-center tw-text-white tw-font-body" i18n="@@okay">okay</p>
  </waiting-for-call>
</div>
